import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import { Grid, Paper, Button, TextField } from "@material-ui/core";

import Axios from "axios";
import { url } from "../../../../config/config";
import Header from "../../../../Component/NavBar/User/Header/Header";
import Footer from "../../../../Component/NavBar/User/Footer/Footer";
import CustomLoader from "../../../../Component/CustomLoader/CustomLoader";
import CustomEmptyMessage from "../../../../Component/CustomEmptyMessage/CustomEmptyMessage";
import { useStyles } from "./BookBy.css";

class BookByGenre extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: {
        categoryName: "",
      },
      category: [],
      isEmpty: false,
    };
  }

  componentDidMount() {
    this.getCategoryData();
  }

  getCategoryData = async () => {
    const response = await Axios.get(`${url}/api/categories`);
    if (response.data.length !== 0) {
      this.setState({
        category: response.data,
      });
    }
  };

  handleChange = (e) => {
    this.setState({
      search: {
        genre: e.target.value,
      },
    });
  };

  compare = (a, b) => {
    const labelA = a.name.toUpperCase();
    const labelB = b.name.toUpperCase();

    let comparison = 0;
    if (labelA > labelB) {
      comparison = 1;
    } else if (labelA < labelB) {
      comparison = -1;
    }
    return comparison;
  };

  handleClick = (genre) => {
    this.props.history.push(`/books/category/genre/${genre}`);
  };

  render() {
    const { classes } = this.props;
    this.state.category.sort(this.compare);
    const filtered = this.state.category.filter((category) => {
      return (
        category.name
          .toLowerCase()
          .indexOf(this.state.search.categoryName.toLowerCase()) !== -1
      );
    });
    return (
      <div>
        <Header />
        <div className={classes.root}>
          <div className={classes.buttonRoot}>
            <Button
              disableRipple
              variant="outlined"
              className={classes.buttonStyle}
              onClick={() => this.props.history.push(`/books/category/author`)}
            >
              Browse Book By Author
            </Button>
            <Button
              disableRipple
              variant="outlined"
              className={classes.buttonStyle}
              onClick={() => this.props.history.push(`/books/category/genre`)}
            >
              Browse Book By Genre
            </Button>
          </div>
          <div
            style={{
              padding: 10,
              fontSize: 30,
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            Category by Genre
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <TextField
              name="genre"
              label="Genre"
              type="text"
              variant="outlined"
              margin="normal"
              placeholder="Search by Genre"
              InputProps={{
                classes: {
                  notchedOutline: classes.notchedOutline,
                  focused: classes.focused,
                },
              }}
              InputLabelProps={{
                classes: {
                  root: classes.labelRoot,
                  focused: classes.labelFocused,
                },
                shrink: true,
              }}
              className={classes.nameInputStyle}
              value={this.state.search.categoryName}
              onChange={this.handleChange}
            />
          </div>

          {this.state.category.length !== 0 ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Grid container spacing={3} style={{ width: "100%" }}>
                {filtered.map((category, index) => (
                  <Grid item xs={12} sm={12} md={6} xl={6} lg={6} key={index}>
                    <Paper
                      onClick={() => this.handleClick(category.name)}
                      className={classes.genrePaper}
                      style={{ backgroundImage: `url(${category.imageUrl})` }}
                    >
                      <div
                        style={{
                          color: "#ffffff",
                          fontSize: 40,
                          fontWeight: "bolder",
                        }}
                      >
                        {category.name}
                      </div>
                    </Paper>
                  </Grid>
                ))}
              </Grid>
            </div>
          ) : this.state.isEmpty === true ? (
            <CustomEmptyMessage message="There is no any book published yet for this category." />
          ) : (
            <CustomLoader />
          )}
          <br />
        </div>
        <Footer />
      </div>
    );
  }
}

export default withStyles(useStyles)(withRouter(BookByGenre));
